
export const errorsMessage = {
  required: 'required',
  email: 'invalid_email_error',
  invalid_date: 'invalid_date',
  case_number: 'case_number_length',
  image_max_size: 'image_max_size',
};
